import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import "./company-dashboard-add-existing-keyresults-popup-card.scss";

const CompanyDashboardAddExistingKeyResultsPopupCard: any = (props: any) => {
  const {
    mainLabel,
    borderColor,
    progressValue,
    onClick,
    objectivesCount,
    initiativesCount,
    lightBorderColor,
    style,
  } = props;

  const isDisabled = style?.opacity === 0.5;

  const cardContent = (
    <button
      className="company-dashboard-key-objective-card"
      onClick={onClick}
      style={{ borderBottom: `3px solid ${borderColor}`, ...style }}
    >
      <div className="company-dashboard-key-objective-card-content">
        <div className="company-dashboard-key-objective-card-content-label-graph">
          <div className="company-dashboard-key-objective-card-content-label">
            <Tooltip title={mainLabel} arrow>
              <div className="company-dashboard-key-objective-card-content-label-main">
                <span>{mainLabel}</span>
              </div>
            </Tooltip>
            <div className="company-dashboard-key-objective-card-content-footer">
              <div
                className="company-dashboard-key-objective-card-content-footer-section"
                style={{ borderRight: "1px solid #E0E0E0" }}
              >
                <div className="company-dashboard-key-objective-card-content-footer-section-label">
                  Objectives
                </div>
                <div className="company-dashboard-key-objective-card-content-footer-section-value">
                  {objectivesCount}
                </div>
              </div>
              <div className="company-dashboard-key-objective-card-content-footer-section">
                <div className="company-dashboard-key-objective-card-content-footer-section-label">
                  Initiatives
                </div>
                <div className="company-dashboard-key-objective-card-content-footer-section-value">
                  {initiativesCount}
                </div>
              </div>
            </div>
          </div>
          <div
            className="company-dashboard-key-objective-card-content-graph"
            style={{ borderColor: borderColor }}
          >
            <Box sx={{ position: "relative", display: "inline-flex" }}>
              <CircularProgress
                variant="determinate"
                value={100}
                size={72}
                sx={{
                  color: lightBorderColor,
                }}
                thickness={6.2}
              />
              <CircularProgress
                variant="determinate"
                value={progressValue}
                size={72}
                sx={{
                  color: borderColor,
                  position: "absolute",
                  left: 0,
                  "& .MuiCircularProgress-circle": {
                    strokeLinecap: "round",
                  },
                }}
                thickness={6.2}
              />
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  component="div"
                  sx={{ color: "#403C6F" }}
                >{`${Math.round(progressValue || 0)}%`}</Typography>
              </Box>
            </Box>
          </div>
        </div>
      </div>
    </button>
  );

  return isDisabled ? (
    <Tooltip
      title="Only key results linked to objectives can be selected."
      placement="top"
    >
      <span>{cardContent}</span>
    </Tooltip>
  ) : (
    cardContent
  );
};

export default CompanyDashboardAddExistingKeyResultsPopupCard;
